import { AC_GROUPS, AC_TYPES, AC_UNITS } from '../AC.types.constant';
import { CriterionType } from '../../../types/screener.type';

const shareRelatedAC: CriterionType[] = [
  {
    id: 'SHR-10',
    label: 'Market cap (M)',
    shortLabel: 'MktCap(M)',
    unit: AC_UNITS.currency,
    group: AC_GROUPS.shareRelated,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'SHR-20',
    label: 'Float',
    shortLabel: 'Float',
    group: AC_GROUPS.shareRelated,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'SHR-30',
    label: 'Float (% of shares o/s)',
    shortLabel: 'Float %',
    group: AC_GROUPS.shareRelated,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'SHR-40',
    label: 'Avg basic shares o/s (M)',
    shortLabel: 'AvgBasicSO(M)',
    group: AC_GROUPS.shareRelated,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'SHR-50',
    label: 'Current shares o/s (M)',
    shortLabel: 'CurrSO(M)',
    group: AC_GROUPS.shareRelated,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'SHR-60',
    label: 'Avg shares o/s (M)',
    shortLabel: 'AvgSO M',
    group: AC_GROUPS.shareRelated,
    type: AC_TYPES.normal,
    withRange: true,
  },
];

export default shareRelatedAC;
